module.exports = __webpack_public_path__ + "static/media/metaknight_0.48a210c0.png";